import React, {Fragment} from 'react';
import {Helmet} from 'react-helmet-async';
import {Link} from 'react-router-dom';

import SiteWrapper from '../../../home-pages/SiteWrapper';
import InnerBanner from '../../../../components/page-title/InnerBanner';
import AboutFour from '../../../../components/about/AboutFour';
import FancyFeatureTwentyTwo from '../../../../components/feature/FancyFeatureTwentyTwo';
import CommonCounter from '../../../../components/counter/CommonCounter';
import Skill from '../../../../components/skill/Skill';

import AdressOne from '../../../../components/adress/AdressOne';
import Info from '../../../../components/adress/Info';
import FooterTwo from '../../../../components/footer/FooterTwo';
import CopyRightFour from '../../../../components/footer/CopyRightFour';

const AboutMe = () => {
    return (
        <SiteWrapper>
            <Helmet>
                <title>About Me || RyanDymock.com</title>
            </Helmet>

                <div className="theme-inner-banner">
                    <InnerBanner intro='About Me' currpage='About Me'/>
                    <img src="images/shape/shape_38.svg" alt="" className="shapes shape-one"/>
                    <img src="images/shape/shape_39.svg" alt="" className="shapes shape-two"/>
                </div>

                <div className="portfolio-gallery-four mt-140 mb-130 lg-mt-90 lg-mb-50" style={{ color: '#fff' }}>
                    <div className="container">
                        Coming Soon!
                    </div>
                </div>

                {/* /.theme-inner-banner */}

                

                <div className="footer-style-two theme-basic-footer">
                    <div className="container">
                    <div className="inner-wrapper">
                            {/* <FooterHome /> */}
                            <div className="bottom-footer">
                                <CopyRightFour />
                            </div>
                        </div>
                    </div>
                </div>

        </SiteWrapper>
    )
}

export default AboutMe
